import { request } from '../request';

export const chatApi = {
  listChats: (params) => {
    const searchParams = new URLSearchParams();
    if (params?.user_id) searchParams.append('user_id', params.user_id);
    if (params?.channel) searchParams.append('channel', params.channel);
    const query = searchParams.toString();
    return request(`/chats${query ? `?${query}` : ''}`);
  },

  createChat: (chat) =>
    request('/chats', {
      method: 'POST',
      body: JSON.stringify(chat)
    }),

  getChat: (chatId) => request(`/chats/${encodeURIComponent(chatId)}`),

  stopChat: (chatId, payload = {}) =>
    request(`/console/chat/stop?chat_id=${encodeURIComponent(chatId)}`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }),

  updateChat: (chatId, chat) =>
    request(`/chats/${encodeURIComponent(chatId)}`, {
      method: 'PUT',
      body: JSON.stringify(chat)
    }),

  deleteChat: (chatId) =>
    request(`/chats/${encodeURIComponent(chatId)}`, {
      method: 'DELETE'
    }),

  batchDeleteChats: (chatIds) =>
    request('/chats/batch-delete', {
      method: 'POST',
      body: JSON.stringify(chatIds)
    })
};

export const sessionApi = {
  listSessions: (params) => {
    const searchParams = new URLSearchParams();
    if (params?.user_id) searchParams.append('user_id', params.user_id);
    if (params?.channel) searchParams.append('channel', params.channel);
    const query = searchParams.toString();
    return request(`/chats${query ? `?${query}` : ''}`);
  },

  getSession: (sessionId) => request(`/chats/${encodeURIComponent(sessionId)}`),

  deleteSession: (sessionId) =>
    request(`/chats/${encodeURIComponent(sessionId)}`, {
      method: 'DELETE'
    }),

  createSession: (session) =>
    request('/chats', {
      method: 'POST',
      body: JSON.stringify(session)
    }),

  updateSession: (sessionId, session) =>
    request(`/chats/${encodeURIComponent(sessionId)}`, {
      method: 'PUT',
      body: JSON.stringify(session)
    }),

  batchDeleteSessions: (sessionIds) =>
    request('/chats/batch-delete', {
      method: 'POST',
      body: JSON.stringify(sessionIds)
    }),

  /** @param {string} sessionId */
  getSessionFiles: (sessionId) => request(`/sessions/${encodeURIComponent(sessionId)}/files`),

  /**
   * 删除会话下的文件或目录（目录递归删除）
   * @param {string} sessionId
   * @param {string} filePath - 相对于会话的文件路径，如 "notes/todo.md" 或 "file.txt"
   */
  deleteSessionFile: (sessionId, filePath) => {
    const encodedPath = String(filePath)
      .split('/')
      .map((seg) => encodeURIComponent(seg))
      .join('/');
    return request(`/sessions/${encodeURIComponent(sessionId)}/files/${encodedPath}`, {
      method: 'DELETE'
    });
  }
};
